import React from 'react';
import { withAlternateArtDisplayOrder } from '../utils/alternateArtDisplay';
import { getOrderCardImageSrc } from '../utils/orderCardImageSrc';
import './OrderSidebarStyleCard.css';

const factionColors = {
  'Remnants of Humanity': '#556B2F',
  'Exolot Dominion': '#4B0082',
  'League of Shadows': '#1A1A1A',
  "Ra's Children": '#F4A460',
  Asrah: '#8B0000',
  'The Sentients': '#ADD8E6',
  Combined: '#FFA500',
};

const combinedFactions = {
  'The Conspiracy': true,
  'The Corrupted Core': true,
  'The Covenant': true,
  'The Divine Syndicate': true,
  'The Forsaken Pact': true,
  'The Hollow': true,
  'The Iron Alliance': true,
  'The Last Crusade': true,
  'The Shadow Consortium': true,
  'The Silent Accord': true,
};

export function getOrderSidebarBorderColor(order) {
  if (!order?.faction_name) {
    return '#FFFFFF';
  }
  if (combinedFactions[order.faction_name]) {
    return factionColors.Combined;
  }
  return factionColors[order.faction_name] || '#FFFFFF';
}

/**
 * Strategy sidebar / Black Ops operative card: full-bleed art, upper-third crop, faction border, text overlay.
 */
export default function OrderSidebarStyleCard({
  order,
  displayName,
  displayCost,
  count = null,
  costLabel = 'Cost',
  isUnowned = false,
  className = '',
  style,
  onClick,
  onMouseEnter,
  onMouseLeave,
  ...rest
}) {
  const displayOrder = order ? withAlternateArtDisplayOrder(order) : null;
  const orderImageSrc = displayOrder ? getOrderCardImageSrc(displayOrder) : null;
  const borderColor = order ? getOrderSidebarBorderColor(order) : '#FFFFFF';
  const name = displayName ?? order?.name ?? '';
  const cost = displayCost ?? order?.cost;

  return (
    <div
      className={`strategy-sidebar-order-entry${isUnowned ? ' strategy-sidebar-order-entry--unowned' : ''}${
        orderImageSrc ? ' strategy-sidebar-order-entry--has-image' : ''
      } ${className}`.trim()}
      style={{ borderColor, ...style }}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...rest}
    >
      {orderImageSrc && (
        <div className="strategy-sidebar-order-bg" aria-hidden="true">
          <img
            className="strategy-sidebar-order-bg-img"
            src={orderImageSrc}
            alt=""
            draggable={false}
          />
        </div>
      )}
      {isUnowned && <span className="strategy-sidebar-order-warning">⚠️</span>}
      <span className="strategy-sidebar-order-line">
        {count != null && (
          <span className="strategy-sidebar-order-count" aria-hidden="true">
            {count}
          </span>
        )}
        <strong className="strategy-sidebar-order-name">{name}</strong>
        <span className="strategy-sidebar-order-cost">
          {costLabel ? `${costLabel} ` : ''}
          {cost}
        </span>
      </span>
    </div>
  );
}
